@if (data) {
  <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xxl-6"
    [ngClass]="{'col-lg-6 col-xxl-6': !isLong }" style="float: left; margin-bottom: 10px;">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="superbold" style="align-items: center; font-size: 1.75rem;">
            @if (icon) {
              <mat-icon> {{icon}} </mat-icon>
            }
            {{title}} ({{ data.length }})
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- <hr /> -->
        @if (data.length > 0) {
          <div style="max-height: 50vh; overflow: auto">
            @for (d of data; track d) {
              <div class="text label-text item-card">
                @if (prop_1) {
                  <mat-card appearance="outlined" (click)="clickEvent(d)">
                    {{ d[prop_1] }}
                    @if (prop_1 && prop_2 && (prop_3 || prop_4 || prop_5 || prop_6)) {
                      <button
                        href="javascript:void()" color="warn" style="float: right;" mat-icon-button
                        (click)="d.isExpanded = !d.isExpanded">
                        @if (!d.isExpanded) {
                          <mat-icon class="mat-18">expand_more</mat-icon>
                        }
                        @if (d.isExpanded) {
                          <mat-icon class="mat-18">expand_less</mat-icon>
                        }
                      </button>
                    }
                    <button (click)="navigateToType(d)" color="primary" style="float: right;" mat-icon-button>
                      <mat-icon class="mat-18">search</mat-icon>
                    </button>
                    @if (prop_2) {
                      <p class="text medium-text" style="margin: 0px;">
                        {{ d[prop_2] }}
                      </p>
                    }
                    @if (d.isExpanded && prop_3) {
                      <p class="text medium-text" style="margin: 0px; padding-left: 15px"
                        >
                        - {{ d[prop_3] }}
                      </p>
                    } @else {
                      <ng-template [ngTemplateOutlet]="noProp_3"></ng-template>
                    }
                    @if (d.isExpanded && prop_4) {
                      <p class="text medium-text" style="margin: 0px; padding-left: 15px"
                        >
                        - {{ d[prop_4] }}
                      </p>
                    }
                    @if (d.isExpanded && prop_5) {
                      <p class="text medium-text" style="margin: 0px; padding-left: 15px"
                        >
                        - {{ d[prop_5] }}
                      </p>
                    }
                    @if (d.isExpanded && prop_6) {
                      <p class="text medium-text" style="margin: 0px; padding-left: 15px"
                        >
                        - {{ d[prop_6] }}
                      </p>
                    }
                  </mat-card>
                } @else {
                  <mat-card appearance="outlined">
                    <h3 class="text medium-text">No property 1 was found.</h3>
                    <mat-progress-bar mode="query">
                    </mat-progress-bar>
                  </mat-card>
                }
              </div>
            }
          </div>
        } @else {
          <p class="text medium-text" style="margin: 0px;">
            No {{title}} found.
          </p>
        }
      </mat-expansion-panel>
    </mat-accordion>
  </div>
} @else {
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-4" style="float: left">
    <mat-card appearance="outlined">
      <h3 class="text label-header-text">
        @if (icon) {
          <mat-icon> {{icon}} </mat-icon>
        }
        {{title}}
      </h3>
      <hr />
      <p class="text medium-text" style="margin: 0px;">
        No data found.
      </p>
    </mat-card>
  </div>
}
